import React from "react";

const Layout5 = ({ data }) => {
    const { video, products = [], title, brand, canvas, infoText, discountText } = data;

    const getCanvasBackground = (canvas, angle = 90) => {
        const type = canvas?.backgroundType || 'gradient';
        if (type === 'gradient') {
            const c1 = canvas?.gradientColor1 || canvas?.backgroundColor || '#e0e0e0';
            const c2 = canvas?.gradientColor2 || '#ffffff';
            return `linear-gradient(${angle}deg, ${c1}, ${c2})`;
        }
        return canvas?.backgroundColor || '#e0e0e0';
    };

    return (
        <div className="relative w-full h-full flex flex-col  overflow-hidden p-5"
            style={{ background: getCanvasBackground(canvas) }}
        >
            <div className="flex items-center justify-center gap-6 mb-5 py-4">
                <div>
                    <img
                        src={brand?.logoUrl}
                        alt="logo"
                        className="h-9 object-cover"
                    />
                </div>
                <h1 className="text-4xl font-semibold text-center  animate-slide-down" style={{ color: canvas?.textColor }}>
                    {title}
                </h1>
            </div>

            <div className="flex flex-1 gap-6">

                <div className="w-[50%] h-full flex flex-col gap-5">
                    {/* Video */}
                    <div className="w-full h-[55%] rounded-xl overflow-hidden shadow-md">
                        <video
                            src={video?.url}
                            autoPlay
                            muted
                            loop
                            className="w-full h-full object-fill"
                        />
                    </div>

                    {/* QR + TEXT */}
                    <div className="flex items-center justify-evenly flex-1 gap-6 h-[45%]">
                        <div>
                            <img
                                src={brand?.qrCodeUrl}
                                alt="qr"
                                className="w-36 h-36 bg-white rounded-md border-2 p-1 border-black animate-slide-left"
                            />
                        </div>

                        <div className="italic text-3xl animate-slide-right">
                            <p className=" font-semibold" style={{ color: canvas?.discountTextColor }}>
                                {discountText}
                            </p>
                            <p style={{ color: canvas?.textColor }}>{infoText}</p>
                        </div>
                    </div>

                </div>

                <div className="w-[20%] h-full grid grid-rows-[1fr_1fr] gap-y-6">
                    <div
                        className="w-full h-full flex justify-center items-center backdrop-blur-md shadow-md rounded-xl p-3"
                        style={{ background: getCanvasBackground(canvas, 135) }}
                    >
                        <img
                            src={products[0]}
                            alt="product"
                            className="w-full h-full object-contain animate-floatY"
                        />
                    </div>

                    <div
                        className="w-full h-full flex justify-center items-center backdrop-blur-md shadow-md rounded-xl p-3"
                        style={{ background: getCanvasBackground(canvas, 135) }}
                    >
                        <img
                            src={products[1]}
                            alt="product"
                            className="w-full h-full object-contain animate-floatY-delay"
                        />
                    </div>
                </div>

                <div className="w-[30%] h-full  rounded-xl overflow-hidden shadow-md">
                    {video?.url2?.endsWith('.gif') ? (
                        <img
                            src={video?.url2}
                            alt="media"
                            className="w-full h-full rounded-xl object-fill"
                        />
                    ) : (
                        <video
                            src={video?.url2}
                            autoPlay
                            muted
                            loop
                            playsInline
                            className="w-full h-full rounded-xl object-fill"
                        />
                    )}
                </div>

            </div>
        </div>
    );
};

export default Layout5;
